/**
 * A bill's state in the shared `StatusPill` (DESIGN.md §1 / §13.1): one tone,
 * one meaning. Paid is emerald (paid is what emerald means); a failed or
 * abandoned charge is red; money still due is amber (needs attention); So
 * far and Void are quiet grey (in progress, or history).
 */
import { useTranslation } from 'react-i18next';
import { StatusPill, type StatusPillTone } from '@/components/shared/StatusPill';
import type { MonthStatus } from '../lib/billing-view';

const TONE: Record<MonthStatus, StatusPillTone> = {
  so_far: 'off',
  paid: 'on',
  payment_failed: 'error',
  due: 'warning',
  void: 'off',
  not_paid: 'error',
};

export function BillingStatusPill({ status, className }: { status: MonthStatus; className?: string }) {
  const { t } = useTranslation('billing');
  return (
    <StatusPill tone={TONE[status]} className={className}>
      {t(`status.${status}`)}
    </StatusPill>
  );
}
